import { map } from 'ramda'
import { useState } from 'react'
import useSWR from 'swr'
import { createContainer } from 'unstated-next'
import { BatchesSchema } from '../Schema'

const DashboardBatchesStore = createContainer(() => {
  const [query, setQuery] = useState('')
  const [filter, setFilter] = useState(true)
  const [courseId, setCourseId] = useState('')

  const { data: batches, error, mutate } = useSWR(
    !courseId ? null : [`/course/${courseId}/batch/list`, map(BatchesSchema)],
  )

  return {
    loading: !batches,
    courseId,
    loadFailed: !!error,
    setCourseId,
    batches,
    query,
    setQuery,
    filter,
    setFilter,
    mutate,
  }
})

export default DashboardBatchesStore
